/* Documents.tsx
    Une page affichant la gestion des documents et des compteurs de documents
    Utilise le composant GenericCrudPage pour lister, ajouter, gérer et supprimer les éléments
    Utilise l'API correspondante pour les opérations de données
*/

// Import Layout
import PageHeader from 'layout/PageHeader';

// Import FontAwesome
import { faFile } from '@fortawesome/free-solid-svg-icons';

// Import Features
import { DocumentCounterCrudCard } from 'features/documentCounters/components/DocumentCounterCrudCard';
import { DocumentsCrudCard } from 'features/documents/components/DocumentsCrudCard';

export const Documents = () => (
	<div className="min-h-screen bg-gray-100 p-6 space-y-6">
		<PageHeader
			icon={faFile}
			title="Documents"
			subtitle="Gérez vos modèles de documents et leurs compteurs"
		/>
		<DocumentCounterCrudCard
			size="lg"
			returnPath="/app/settings"
			returnLabel="Paramètres"
			forceIcon
		/>
		<DocumentsCrudCard
			size="lg"
			returnPath="/app/settings"
			returnLabel="Paramètres"
			forceIcon
		/>
	</div>
);
